import { Link } from "react-router-dom";
import PageHeader from "@/components/PageHeader";
import { Reveal } from "@/components/Reveal";
import { ArrowRight } from "lucide-react";
import { INDUSTRIES, GALLERY } from "@/data/catalog";

export default function Industries() {
  return (
    <div data-testid="industries-page">
      <PageHeader overline="Industries We Serve" title="Packaging tailored for every business." subtitle="From food manufacturers and retailers to industrial businesses and e-commerce brands, ElitzPacks delivers packaging designed for the unique requirements of every industry." />

      <section className="mx-auto max-w-[1400px] px-5 lg:px-10 py-12">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {INDUSTRIES.map((ind, i) => (
            <Reveal key={ind} delay={(i % 4) * 0.05}>
              <div className="group relative overflow-hidden rounded-3xl border border-border bg-card p-7 h-40 flex flex-col justify-between hover:border-royal/40 transition-colors">
                <span className="font-mono-accent text-xs text-muted-foreground">{String(i + 1).padStart(2, "0")}</span>
                <h3 className="font-heading text-xl font-bold text-foreground group-hover:text-royal transition-colors">{ind}</h3>
                <div className="absolute -right-6 -bottom-6 h-24 w-24 rounded-full bg-emerald/5 group-hover:bg-emerald/15 transition-colors" />
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="mx-auto max-w-[1400px] px-5 lg:px-10 py-10">
        <div className="rounded-4xl overflow-hidden relative">
          <img src={GALLERY[3]} alt="Industries" className="w-full aspect-[16/6] object-cover" />
          <div className="absolute inset-0 bg-navy/70 grid place-items-center text-center px-6">
            <div>
              <h2 className="font-heading text-3xl lg:text-4xl font-extrabold text-white max-w-xl mx-auto">Don&rsquo;t see your industry? We&rsquo;ll build a solution for it.</h2>
              <Link to="/request-quote" className="mt-6 inline-flex items-center gap-2 rounded-full bg-white text-navy px-7 py-3.5 font-semibold hover:bg-emerald hover:text-white transition-colors">Talk to an expert <ArrowRight size={18} /></Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
